import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';
import { landing_config } from "../../landing_config";
import { ILandingOrigen } from "../../types/LandingOrigen";

export const obtenerOrigen = async (): Promise<ILandingOrigen> => {
    try {
        const params = {
            hash: await getApiHash(),
        }
        const headers = {
            'content-type': 'application/json',
            "Authorization": 'Bearer ' + await getApiToken()
        }

        const resp = await Axios.post(await getPathName() + "/GetParametrosOrigenJSON", params,
            {
                headers: headers
            });

        const parametros = landing_config.find(config => config.origen === resp.data.origen);
        //const parametros = landing_config.find(conf => conf.origen === "YPFRUTA");
        if (parametros) {
            return parametros;
        } else {
            return {
                ready: true
            } as ILandingOrigen
        }
    } catch (error) {
        console.log(error);
        return {
            ready: true
        } as ILandingOrigen
    }
}